import Api from './Api'

export default {

    all() {
        return Api().get('/constructions/all')
            .catch(error => { console.log(error.response) })
    },

    /*
    getFilter(value) {
        return Api().get('/tenders', {
            params: {
                organization: value.organization,
                active: value.active,
                important: value.important,
                status: value.status,
                from: value.from,
                to: value.to
            }
        })
        .catch(error => { console.log(error.response) })
    },
    */

    deleteItem(id) {
        return Api().delete(`/constructions/${id}`)
                .catch(error => { console.log(error) })
    },

    addItem(value) {
        return Api().post(`/constructions`, value)
                .catch(error => { console.log(error) })
    },

    editItem(id, value) {
        return Api().put(`/constructions/${id}`, value)
                .catch(error => { console.log(error) })
    }

}